import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingBasket } from "@fortawesome/pro-regular-svg-icons/faShoppingBasket";
import { Card } from "components/Card";

const ProductCard = (props) => {
  const { product } = props;
  const { productName, productImage, price, imageBySku } = product;

  return (
    <Card
      className="flex flex-1 flex-col !py-5 !px-4 gap-y-2 min-w-0"
      shadow={false}
      data-testid="content__products--card"
    >
      <div className="flex justify-center items-start self-stretch relative px-[42px] h-full">
        <img
          className="object-contain object-center max-w-full select-none max-h-42"
          src={
            imageBySku || productImage?.location || "/images/placeholder.jpg"
          }
          alt={productName}
          data-testid="content__products--image"
          draggable="false"
          onDragStart={(e) => e.preventDefault()}
          style={{ userSelect: "none", WebkitUserDrag: "none" }}
        />
      </div>
      <div className="h-10">
        <h3
          className="!text-base font-bold leading-5 text-brand-primary-600 text-left"
          data-testid="content__products--title"
        >
          {productName}
        </h3>
      </div>

      <hr className="border-t-brand-grey-100" />

      <div className="flex items-center justify-end gap-x-8">
        <p
          className="text-2xl font-bold text-brand-red"
          data-testid="content__products--price"
        >
          £{(price?.incTax / 100).toFixed(2)}
        </p>
      </div>
      <div className="flex justify-center w-full">
        <button
          onClick={() => {
            // Add to basket handler - can be connected to basket functionality
            console.log("Add to basket:", product);
          }}
          className="w-full lg:w-3/4 bg-brand-success-600 text-brand-white font-bold text-sm py-[10px] px-4 mt-4 rounded-[32px] hover:bg-brand-success/90 focus:bg-brand-success focus:ring-brand-success focus:ring active:bg-brand-success/80 active:ring transition-all flex items-center justify-center gap-2"
          data-testid="content__products--add-to-basket"
        >
          Add to Basket
          <FontAwesomeIcon icon={faShoppingBasket} className="w-4 h-4" />
        </button>
      </div>
    </Card>
  );
};

export default ProductCard;
